// extracted by mini-css-extract-plugin
export default {"item":"tab_item__wo-qF","tab":"tab_tab__18+n4","tab--active":"tab_tab--active__pQSpl","borderBottom":"tab_borderBottom__fI6KB"};